/*
 * a custom api containing string related utility functions
 */
const StringUtils = {
    isNull(str) {
        return !str;
    },
    isNullOrWhiteSpace(str) {
        return str === null || str == undefined || str.match(/^ *$/) !== null;
    }
};
export default StringUtils;
